module.exports = {
    EmailRegex: "^\w+([-+.']\w+)*@\w + ([-.]\w +)*\.\w + ([-.]\w +)* $",
    PhoneNumberRegex: "^[0-9]{3}-[0-9]{3}-[0-9]{4}$",
    ZipcodeRegex: /^\d{5}$/,
    PostalCodeRegex: /^[A-Z]\d[A-Z][ -]?\d[A-Z]\d$/i,
    EMAIL_REGEX : /^[^\s@]+@[^\s@]+\.[^\s@]+$/
};